import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { InvestmentFinancialModel } from './investment-financial.model';
import { InvestmentFinancialFormComponent } from './investment-financial-form.component';
import { InvestmentFinancialService } from './investment-financial.service';


@Component({
    selector: 'convfact-dialog-import-account-investment-financial',
    templateUrl: './investmentFinancial-dialog-importAccount.component.html',
    styleUrls: ['./investment-financial.component.css'],
    standalone: false
})
export class InvestmentFinancialDialogImportAccount {

    dataImport: InvestmentFinancialModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<InvestmentFinancialFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public investmentFinancialService: InvestmentFinancialService,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "Financial").then(result => {
            this.dialogRef.close();
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
